// extracted by mini-css-extract-plugin
export default {"wrapper":"AccountBills_wrapper__h45Ir","formWrapper":"AccountBills_formWrapper__GFoHu"};